import React from 'react'

const Notifications = ()=> {
  return (
    <div className='page'>
        <h2 className='pageTitle'>While we're still in development, please visit Profile for more information</h2>
    </div>
  )
}

export default Notifications